export default __webpack_public_path__ + "static/media/pedidosya.450c3eb3.svg";